<template>
	<div class="module_page page_content institution" aria-label="Institution Details view content page">
	  <div class="hidden-container">
	    <form method="POST" id="multipleFileUploadForm" enctype="multipart/form-data" v-on:submit.prevent>
	      <input type="file" id="thumbnailFileList" ref="thumbnailFileList" name="thumbnailFile" @change="thumbnailToBeUploaded" />
	    </form>
	  </div>
	  <div class="row page-heading">
	    <div class="col-8 input module_heading" role="heading" aria-level="1">
	      <span class="module_icon ic-inst"></span>
	      <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
	    </div>
	    <div class="col-4 btn_container">
	      <b-btn @click="doneClicked">done</b-btn>
	      <b-btn @click="saveClicked">save</b-btn>
	      <b-btn class="btn-cancel" @click="cancelClicked" title="Cancel"><span class="icon-cross"></span></b-btn>
	    </div>
	  </div>
	  <div class="page_content_container">
	    <institution-menu :uuid="uuid" :active="'details'"></institution-menu>
	    <div class="row pg_content">
	      <div class="col-12">
	        <div class="row">
	          <div class="col-12 pg_fld_sec">
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label">Institution Name</label> <span class="fld_req">*</span>
	                      <span id='nameInputField' class="exclamation-circle"><span class="ico-error"></span></span>
	                      <b-popover target="nameInputField" triggers="hover" container="nameInfo" :title="nameNotEditableWarningText"></b-popover>
	                    </div>
	                    <div class="fld_input">
	                      <input disabled v-model="title"></input>
	                    </div>
	                  </div>
	                </div>
	                <div class="row" style="margin-top: 30px;">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label" for="institutionLevel">Level</label>
	                    </div>
	                    <div class="fld_input">
	                      <select id="institutionLevel" v-model="level">
	                        <option v-for="level in institutionLevels" v-bind:value="level">
	                          {{ level }}
	                        </option>
	                      </select>
	                    </div>
	                  </div>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label">Description</label>
	                    </div>
	                    <div class="fld_input">
	                      <textarea v-model="description" class="description"></textarea>
	                    </div>
	                  </div>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="institutionType">Type</label>
	                </div>
	                <div class="fld_input">
	                  <select id="institutionType" v-model="type">
	                    <option v-for="type in institutionTypes" v-bind:value="type">
	                      <!-- capitalize first letter -->
	                      {{ type.charAt(0).toUpperCase() + type.slice(1) }}
	                    </option>
	                  </select>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="orgType">Org Type</label>
	                </div>
	                <div class="fld_input">
	                  <select id="orgType" v-model="orgType">
	                    <option v-for="otype in orgTypes" v-bind:value="otype">
	                      <!-- capitalize first letter -->
	                      {{ otype }}
	                    </option>
	                  </select>
	                </div>
	              </div>

	            </div>
	            <div class="row pg_fld_row">
					<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">URL</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="uri" type="url"></input>
	                </div>
	              </div>	              
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">SSO URL</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="ssoUrl"></input>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">SSO Path</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="path"></input>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">SSO Logout URL</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="ssoLogoutUrl"></input>
	                </div>
	              </div>
	            </div>
              	<div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Alert Email</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="alertEmail"></input>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">State</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="state"></input>
	                </div>
	              </div>
	            </div>
              	<div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Partner Home Url</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="partnerHomeUrl"></input>
	                </div>
	              </div>              	
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Orientation Course Enrollment Emails</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="orientationEnrollmentEmail"></input>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                </div>
	                <div class="fld_input">
	                </div>
	              </div>
	            </div>

              	<div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Support Name</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="supportName"></input>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Support Email</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="supportEmail"></input>
	                </div>
	              </div>
	          	</div>
              	<div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Employer Support Name</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="employerSupportName"></input>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Employer Support Email</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="employerSupportEmail"></input>
	                </div>
	              </div>
	          	</div>
              	<div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Employer Phone</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="employerPhone"></input>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Employer Fax</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="employerFax"></input>
	                </div>
	              </div>
	          	</div>
              	<div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Enable Item Analysis Report</label>
	                </div>
	                <div class="fld_input checkbox_container">
	                  <input type="checkbox" v-model="sendItemAnalysisReport"></input>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Item Analysis Report Email</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="itemAnalysisReportEmails"></input>
	                </div>
	              </div>
	          	</div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Redirect URL after SSO</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="redirectUrl"></input>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Short Name</label>
	                </div>
	                <div class="fld_input">
	                  <b-form-input v-model.trim="shortName" @input="forceLowerCase($event, 'shortName')" @keydown.space.prevent style="height: 24px !important;"></b-form-input>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Phone No.</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="phonenumber"></input>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Open Id</label>
	                </div>
	                <div class="fld_input">
	                  <b-form-input v-model.trim="openId" @input="forceUpperCase($event, 'openId')" style="height: 24px !important;"></b-form-input>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label">Fax No.</label>
	                    </div>
	                    <div class="fld_input">
	                      <input v-model="faxnumber"></input>
	                    </div>
	                  </div>
	                </div>
	                <div class="row" style="margin-top: 30px;">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label" for="institutionType">Address</label>
	                    </div>
	                    <div class="fld_input">
	                      <textarea v-model="address" class="address"></textarea>
	                    </div>
	                  </div>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label">Logo</label>
	                    </div>
	                    <div class="fld_input">
	                      <div class="thumbnail_container">
	                        <btn v-if="!showAddThumbnailModal" class="btn" @click="addThumbnailClicked">upload logo</btn>
	                        <img v-if="showPreview && logoUri" id="institutionThumbnail" :src="logoUri" class="thumbnail_image">
	                        <span v-else class="ic ico-buildingCollege"></span>
	                      </div>
	                      <b-modal ref="modal" id="addNewThumbnail" v-model="showAddThumbnailModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup popup_add_thumbnail">
	                        <div slot="modal-header" class="popover-header">
	                          <div class="popup-heading">Update Thumbnail</div>
	                          <button class="btn_close" aria-label="close" @click="cancelAddThumbnail">
	                          <span class="ic-close"></span>
	                          </button>
	                        </div>
	                        <div class="row">
	                          <div class="col-4">
	                            <div class="thumbnail_msg">How your thumbnail will appear</div>
	                            <div class="thumbnail_container">
	                              <b-btn v-if="isUploadingThumbnail || (logo && logo.length > 0)" @click.stop="removeThumbnailClicked" class="btn">remove logo</b-btn>
	                              <img v-if="showPreview && logoUri" id="institutionThumbnail" :src="logoUri">
	                              <span v-else class="ic ico-buildingCollege"></span>
	                            </div>
	                            <span v-if="!showPreview">Preview unavailable</span>
	                          </div>
	                          <div class="col-7 right-model-box">
	                            <div class="row fld_row">
	                              <div class="col-1 fld_col_label">
	                                <label>URL</label>
	                              </div>
	                              <div class="col-8 fld_col_input">
	                                <input :disabled="isUploadingThumbnail" v-model="logoUri" placeholder="http://"></input>
	                              </div>
	                              <div class="col-3 btn_container">
	                              </div>
	                            </div>
	                            <div class="row fld_row msg_row">
	                              <div class="col-1"></div>
	                              <div class="col-11 msg">Add image url for thumbnail.</div>
	                            </div>
	                            <div class="row txt_sep_row">
	                              <div class="col-12">OR</div>
	                            </div>
	                            <div class="row fld_row">
	                              <div class="col-1 fld_col_label">
	                                <label for="newThumbnailFileName">File</label>
	                              </div>
	                              <div class="col-8 fld_col_input">
	                                <input id="newThumbnailFileName" disabled v-model="logo" placeholder="choose a file from your computer"></input>
	                              </div>
	                              <div class="col-3 fld_col_btn">
	                                <b-btn :disabled="isUploadingThumbnail" @click.stop="chooseFile(true)">add file</b-btn>
	                              </div>
	                            </div>
	                            <div class="row msg_row">
	                              <div class="col-1"></div>
	                              <div class="col-11 msg">Select a jpg, jpeg, bmp, gif or png file.</div>
	                            </div>
	                          </div>
	                        </div>
	                        <div slot="modal-footer">
	                          <b-btn @click="addNewThumbnail">save and next</b-btn>
	                          <b-btn @click="cancelAddThumbnail">cancel</b-btn>
	                        </div>
	                      </b-modal>
	                    </div>
	                  </div>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Self Registration Custom Text</label>
	                </div>
	                <div class="fld_input">
	                  <editor api-key="no-api-key"
	                    v-model.trim="selfRegistrationMessage"
	                    :init="({
	                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
	                      menubar: false,
	                      plugins: plugins,
	                      toolbar: toolbar,
	                      branding: false,
	                      statusbar: false,
	                      end_container_on_empty_block: true
	                    })"
	                    @onInit="handlerInit"
	                    id="selfRegistrationMessageId">
	                  </editor>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Refund Policy</label>
	                </div>
	                <div class="fld_input">
	                  <editor api-key="no-api-key"
	                    v-model.trim="refundPolicy"
	                    :init="({
	                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
	                      menubar: false,
	                      plugins: plugins,
	                      toolbar: toolbar,
	                      branding: false,
	                      statusbar: false,
	                      end_container_on_empty_block: true
	                    })"
	                    @onInit="handlerRefundInit"
	                    id="refundPolicyId">
	                  </editor>
	                </div>
	              </div>	              
	            </div>
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Refund Policy Link</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="refundPolicyLink"></input>
	                </div>
	              </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Privacy Policy Link</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="privacyPolicyLink"></input>
	                </div>
	              </div>
	            </div>
              <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Purchase Expiration Custom Message</label>
	                </div>
	                <div class="fld_input">
	                  <editor api-key="no-api-key"
	                    v-model.trim="purchaseExpirationMessage"
	                    :init="({
	                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
	                      menubar: false,
	                      plugins: plugins,
	                      toolbar: toolbar,
	                      branding: false,
	                      statusbar: false,
	                      end_container_on_empty_block: true
	                    })"
	                    @onInit="handlerPurchaseMessageInit"
	                    id="purchaseExpirationMessageId">
	                  </editor>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Buy Flow Custom Message</label>
	                </div>
	                <div class="fld_input">
	                  <editor api-key="no-api-key"
	                    v-model.trim="buyFlowMessage"
	                    :init="({
	                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
	                      menubar: false,
	                      plugins: plugins,
	                      toolbar: toolbar,
	                      branding: false,
	                      statusbar: false,
	                      end_container_on_empty_block: true
	                    })"
	                    @onInit="handlerBuyFlowMessageInit"
	                    id="buyFlowMessageId">
	                  </editor>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label">Learner Dashboard Path</label>
	                    </div>
	                    <div class="fld_input">
	                      <input v-model="learnerDashboard"></input>
	                    </div>
	                  </div>
	                </div>
	                
	                <div class="row" style="margin-top: 30px;">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label" for="institutionType"> Invoice Payment Link</label>
	                    </div>
	                    <div class="fld_input">
	                      <input v-model="invoicePaymentLink"></input>
	                    </div>
	                  </div>
	                </div>
	                <div class="row" style="margin-top: 30px;">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label" for="institutionType">Learner Location Report Map URL</label>
	                    </div>
	                    <div class="fld_input">
	                      <input v-model="locationMapEmbbedURL"></input>
	                    </div>
	                  </div>
	                </div>

	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label">Learner Dashboard Background</label>
	                    </div>
	                    <div class="fld_input">
	                      <div class="thumbnail_container">
<!--	                        <btn v-if="!showAddThumbnailModal" class="btn" @click="addThumbnailClicked">upload Image</btn>
-->
	                        <img  id="institutionThumbnail" :src="dashboardBgImage" class="thumbnail_image">
	                      </div>
<!--	                      
	                      <b-modal ref="modal" id="addNewThumbnail" v-model="showAddThumbnailModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup popup_add_thumbnail">
	                        <div slot="modal-header" class="popover-header">
	                          <div class="popup-heading">Update Thumbnail</div>
	                          <button class="btn_close" aria-label="close" @click="cancelAddThumbnail">
	                          <span class="ic-close"></span>
	                          </button>
	                        </div>
	                        <div class="row">
	                          <div class="col-4">
	                            <div class="thumbnail_msg">How your thumbnail will appear</div>
	                            <div class="thumbnail_container">
	                              <b-btn v-if="isUploadingThumbnail || (logo && logo.length > 0)" @click.stop="removeThumbnailClicked" class="btn">remove logo</b-btn>
	                              <img v-if="showPreview && logoUri" id="institutionThumbnail" :src="logoUri">
	                              <span v-else class="ic ico-buildingCollege"></span>
	                            </div>
	                            <span v-if="!showPreview">Preview unavailable</span>
	                          </div>
	                          <div class="col-7 right-model-box">
	                            <div class="row fld_row">
	                              <div class="col-1 fld_col_label">
	                                <label>URL</label>
	                              </div>
	                              <div class="col-8 fld_col_input">
	                                <input :disabled="isUploadingThumbnail" v-model="logoUri" placeholder="http://"></input>
	                              </div>
	                              <div class="col-3 btn_container">
	                              </div>
	                            </div>
	                            <div class="row fld_row msg_row">
	                              <div class="col-1"></div>
	                              <div class="col-11 msg">Add image url for thumbnail.</div>
	                            </div>
	                            <div class="row txt_sep_row">
	                              <div class="col-12">OR</div>
	                            </div>
	                            <div class="row fld_row">
	                              <div class="col-1 fld_col_label">
	                                <label for="newThumbnailFileName">File</label>
	                              </div>
	                              <div class="col-8 fld_col_input">
	                                <input id="newThumbnailFileName" disabled v-model="logo" placeholder="choose a file from your computer"></input>
	                              </div>
	                              <div class="col-3 fld_col_btn">
	                                <b-btn :disabled="isUploadingThumbnail" @click.stop="chooseFile(true)">add file</b-btn>
	                              </div>
	                            </div>
	                            <div class="row msg_row">
	                              <div class="col-1"></div>
	                              <div class="col-11 msg">Select a jpg, jpeg, bmp, gif or png file.</div>
	                            </div>
	                          </div>
	                        </div>
	                        <div slot="modal-footer">
	                          <b-btn @click="addNewThumbnail">save and next</b-btn>
	                          <b-btn @click="cancelAddThumbnail">cancel</b-btn>
	                        </div>
	                      </b-modal>
-->	                      
	                    </div>
	                  </div>
	                </div>
	              </div>
	            </div>

              <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Learn More Flow Custom Message</label>
	                </div>
	                <div class="fld_input">
	                  <editor api-key="no-api-key"
	                    v-model.trim="learnFlowMessage"
	                    :init="({
	                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
	                      menubar: false,
	                      plugins: plugins,
	                      toolbar: toolbar,
	                      branding: false,
	                      statusbar: false,
	                      end_container_on_empty_block: true
	                    })"
	                    @onInit="handlerLearnFlowMessageInit"
	                    id="learnFlowMessageId">
	                  </editor>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">User Suspension Message</label>
	                </div>
	                <div class="fld_input">
	                  <editor api-key="no-api-key"
	                    v-model.trim="userSuspensionMessage"
	                    :init="({
	                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
	                      menubar: false,
	                      plugins: plugins,
	                      toolbar: toolbar,
	                      branding: false,
	                      statusbar: false,
	                      end_container_on_empty_block: true
	                    })"
	                    @onInit="handlerSuspensionMessageInit"
	                    id="userSuspensionMessageId">
	                  </editor>
	                </div>
	              </div>	              
	            </div>
	          </div>
	          <!-- .pg_fld_sec -->
	        </div>
	      </div>
	      <!-- .dasboard-left-section -->
	    </div>
	  </div>
	  <!-- .page-content -->
	  <div class="loading-spinner">
	    <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-disabled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
	      <div class="text-center" style="color: #FFF">
	        <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
	      </div>
	    </b-modal>
	  </div>
	</div>
</template>

<script>
/* global AWS:true */
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import InstitutionHeader from './InstitutionHeader'
import { AwsObject } from '../aws'
import Editor from '@tinymce/tinymce-vue'
import _ from 'lodash'

var getFileName = function (fileName) {
  if (!fileName && fileName !== null) {
    return null
  }
  return fileName.replace(/\.\w+$/g, '')
}

var getUpdatedFileName = function (title, fileName) {
  var ext = fileName.substr((~-fileName.lastIndexOf('.') >>> 0) + 2)
  if (ext !== '' || ext !== null) {
    return (title + '.' + ext)
  } else {
    return fileName
  }
}

var FileObject = function (title, file, size, timestamp, type) {
  this.title = getFileName(title)
  this.file = file
  this.fileName = getUpdatedFileName(this.title, title)
  this.size = size
  this.contentFileType = type
  this.timestamp = timestamp
  this.id = timestamp
  // added
  // this.uri = file.uri
}

var clone = function (obj) {
  if (obj === null || typeof obj !== 'object') return obj
  var copy = obj.constructor()
  for (var attr in obj) {
    if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
  }
  return copy
}

export default {
  name: 'editInstitutionDetails',
  props: ['uuid'],
  components: {
  	Editor,
    InstitutionMenu,
    InstitutionHeader
  },
  data: () => {
    return {
      address: '',
      description: '',
      errors: [],
      faxnumber: '',
      learnerDashboard:'',
      invoicePaymentLink:'',
      locationMapEmbbedURL:'',
      fileUploadArray: [],
      institutionLevels: ['Graduate', 'Master', 'Certificate', 'Doctrate'],
      institutionTypes: ['online', 'campus'],
      orgTypes : ['INSTITUTION', 'EMPLOYER'],
      isEditingThumbnail: false,
      level: '',
      lmsConnectorPackage: false,
      logo: '',
      logoCopy: '',
      logoUri: '',
      dashboardBgImage:'',
      dashboardBgImageUri:'',
      logoUriCopy: '',
      openId: '',
      ssoUrl: '',
      ssoLogoutUrl: '',
      partnerHomeUrl:'',
      state:'',
      path: '',
      redirectUrl: '',
      phonenumber: '',
      showAddThumbnailModal: false,
      showPreview: true,
      title: '',
      type: '',
      orgType:'INSTITUTION',
      uri: '',
      refundPolicyLink: '',
      refundPolicy: '',
      privacyPolicyLink: '',
      shortName: null,
      nameNotEditableWarningText: 'Institution names cannot be changed once created',
      selfRegistrationMessage: null,
      purchaseExpirationMessage: null,
      buyFlowMessage: null,
      learnFlowMessage: null,
      userSuspensionMessage: null,
      supportEmail: '',
      employerSupportName: '',
      employerSupportEmail: '',
      employerPhone: '',
      employerFax: '',
      alertEmail: '',
      orientationEnrollmentEmail:'',
      supportName: '',
      itemAnalysisReportEmails: '',
      sendItemAnalysisReport: false,
      plugins: 'lists  autolink charmap code hr link textcolor',
      toolbar: 'bold italic | fontsizeselect | alignleft aligncenter alignright | forecolor backcolor | removeformat link unlink'
    }
  },
  mounted () {
    this.loadCurrentEnvironment().then(res => {
      AwsObject(res)
    })
    this.loadInstitution()
  },
  methods: {
    ...mapActions([
      'loadLibrariesForUser',
      'loadInstitutionDetail',
      'storeInstitution',
      'loadUserAdvisor',
      'loadLogDashboardActivity',
      'uploadContentAndGetUri',
      'updateFileUriAndVersionIdAfterS3Upload',
      'loadCurrentEnvironment'
    ]),
    handlerInit (ev, editor) {
      $('#selfRegistrationMessageId_ifr').css({width: '100%', height: '123px', border: '1px solid #ccc'})
    },
    handlerRefundInit (ev, editor) {
      $('#refundPolicyId_ifr').css({width: '100%', height: '123px', border: '1px solid #ccc'})
    },

    handlerPurchaseMessageInit (ev, editor) {
      $('#purchaseExpirationMessageId_ifr').css({width: '100%', height: '123px', border: '1px solid #ccc'})
    },
    handlerBuyFlowMessageInit (ev, editor) {
      $('#buyFlowMessageId_ifr').css({width: '100%', height: '123px', border: '1px solid #ccc'})
    },
    handlerLearnFlowMessageInit (ev, editor) {
      $('#learnFlowMessageId_ifr').css({width: '100%', height: '123px', border: '1px solid #ccc'})
    },
    handlerSuspensionMessageInit (ev, editor) {
      $('#userSuspensionMessageId_ifr').css({width: '100%', height: '123px', border: '1px solid #ccc'})
    },

    forceUpperCase (e, prop) {
      e = e.trim().toUpperCase()
      this.$set(this.$data, prop, e)
    },
    forceLowerCase (e, prop) {
      e = e.replace(' ', '').toLowerCase()
      this.$set(this.$data, prop, e)
    },
    loadInstitution () {
      this.loadLogDashboardActivity({action: 'viewInstitutionDetailsView', page: 'institutionDetailsView', link: '', entityUuid: this.uuid})
      this.loadInstitutionDetail(this.institutionId).then(response => {
        if (!response || !response.uuid) {
          return
        }
        this.title = response.title
        this.level = response.level
        this.description = response.description
        this.type = response.type
        this.orgType = response.orgType
        this.uri = response.uri
        this.address = response.address
        this.phonenumber = response.phonenumber
        this.faxnumber = response.faxnumber
        this.learnerDashboard = response.learnerDashboard
        this.invoicePaymentLink = response.invoicePaymentLink
        this.locationMapEmbbedURL = response.locationMapEmbbedURL
        this.openId = response.openId
        this.ssoUrl = response.ssoUrl
        this.ssoLogoutUrl = response.ssoLogoutUrl
        this.partnerHomeUrl = response.partnerHomeUrl
        this.state = response.state
        this.path = response.path
        this.redirectUrl = response.redirectUrl
        this.logo = response.logo
        this.logoUri = response.logo // transient field
        this.dashboardBgImageUri = response.dashboardBgImage
        this.dashboardBgImage = response.dashboardBgImage
        this.selfRegistrationMessage = response.selfRegistrationMessage
        this.purchaseExpirationMessage = response.purchaseExpirationMessage
        this.buyFlowMessage = response.buyFlowMessage
        this.learnFlowMessage = response.learnFlowMessage
        this.userSuspensionMessage = response.userSuspensionMessage
        this.shortName = response.shortName
        this.supportName = response.supportName
        this.supportEmail = response.supportEmail
        this.employerSupportName = response.employerSupportName
        this.employerSupportEmail = response.employerSupportEmail
        this.employerPhone = response.employerPhone
        this.employerFax = response.employerFax
        this.sendItemAnalysisReport = response.sendItemAnalysisReport
        this.itemAnalysisReportEmails = response.itemAnalysisReportEmails
        this.alertEmail = response.alertEmail
        this.orientationEnrollmentEmail = response.orientationEnrollmentEmail
        this.refundPolicy = response.refundPolicy
        this.refundPolicyLink =  response.refundPolicyLink
        this.privacyPolicyLink = response.privacyPolicyLink
      })
    },
    cancelClicked () {
      return this.$router.push({ name: 'institutionDetails', params: { uuid: this.uuid } })
    },
    saveClicked () {
      let redirectToDetailPage = false
      this.onSubmit(redirectToDetailPage)
    },
    doneClicked () {
      let redirectToDetailPage = true
      this.onSubmit(redirectToDetailPage)
    },
    addThumbnailClicked () {
      this.showAddThumbnailModal = true
      this.isEditingThumbnail = true
      this.logoUriCopy = this.logoUri.slice(0)
      this.logoCopy = this.logo.slice(0)
    },
    removeThumbnailClicked () {
      this.isEditingThumbnail = true
      this.showPreview = true
      this.logo = ''
      this.logoUri = ''
    },
    cancelAddThumbnail () {
      this.logo = this.logoCopy
      this.logoUri = this.logoUriCopy
      this.isEditingThumbnail = false
      this.showAddThumbnailModal = false
      this.errors = []
      this.fileUploadArray = []
    },
    addNewThumbnail () {
      if (this.logo !== this.logoUri) {
        // user entered url instead of uploading local file, no upload necessary
        this.logo = this.logoUri
      } else {
        this.uploadFiles()
      }
      this.showAddThumbnailModal = false
      this.isEditingThumbnail = false
    },
    chooseFile () {
      $('input[type=file][id=thumbnailFileList]').click()
    },
    thumbnailToBeUploaded (ev) {
      this.fileUploadArray = []
      var files = ev.target.files || ev.dataTransfer.files
      if (!files.length || files.length <= 0) {
        return
      }
      this.logoUri = files[0].name
      this.logo = files[0].name
      this.prepareFileUploadArray(files)
      this.showPreview = false
    },
    prepareFileUploadArray (files) {
      if (!files || files.length === 0) {
        return
      }
      let timestamp = new Date().getTime()
      for (var i = 0; i < files.length; i++) {
        timestamp = timestamp + i
        this.addFileToUploadArray(files[i], timestamp)
      }
    },
    addFileToUploadArray (newFile, timestamp) {
      let isFound = _.find(this.fileUploadArray, function (file) {
        return ((newFile.name === file.title) && (newFile.size === file.size))
      })

      if (!isFound) {
        this.fileUploadArray.push(new FileObject(newFile.name, newFile, newFile.size, timestamp, newFile.type))
      }
    },
    uploadFiles () {
      let fileUploadArrayClone = clone(this.fileUploadArray)
      let contentListToCreate = []
      for (var i = 0; i < fileUploadArrayClone.length; i++) {
        let content = fileUploadArrayClone[i]
        let item = {
          'title': content.title,
          'lastModifiedDate': content.contentFileType.timestamp,
          'contentFileType': content.contentFileType,
          'fileName': content.fileName,
          'timestamp': content.timestamp,
          'logo': content.logo,
          'logoUri': content.logoUri
        }
        contentListToCreate.push(item)
      }
      if (contentListToCreate.length <= 0) {
        return
      }
      this.showLoader()
      this.uploadContentAndGetUri({
        learningSpaceId: this.institutionId,
        contents: contentListToCreate,
        success: this.uploadFileAfterCreateContentSuccessCallback,
        failure: this.uploadFileAfterCreateContentErrorCallback
      })
    },
    uploadFileAfterCreateContentSuccessCallback (response) {
      var createdContents = response.createdContents
      if (createdContents.length > 0) {
        // uploading files on S3 for created contents
        var fileUploadArrayClone = clone(this.fileUploadArray)
        this.uploadLearningContentFilesOnS3(createdContents, fileUploadArrayClone)
      }
      this.fileUploadArray = []
      this.showPreview = true
      this.showSuccessPopup()
    },
    uploadFileAfterCreateContentErrorCallback (response) {
      console.log('Error occured while creating content(s) ', response)
      this.hideLoader()
    },
    uploadLearningContentFilesOnS3 (createdContents, fileUploadArrayClone) {
      var filesToBeUploaded = []
      $.each(createdContents, (index, content) => {
        for (var i = 0; i < fileUploadArrayClone.length; i++) {
          var fileData = fileUploadArrayClone[i]
          if (content.fileName === fileData.fileName) {
            var key = content.uuid + '-' + content.fileName
            filesToBeUploaded.push({'uuid': content.uuid, 'key': key, 'uri': content.uri, 'fileData': fileData})
            break
          }
        }
      })
      if (filesToBeUploaded.length > 0) {
        this.storeFilesToS3(filesToBeUploaded)
      }
    },
    storeFilesToS3 (filesToBeUploaded) {
      var awsRef = new AWS.S3()
      var s3Bucket = this.currentEnvironment.s3Bucket
      $.each(filesToBeUploaded, (i, item) => {
        var params = {
          Key: item.key,
          Bucket: s3Bucket,
          ContentType: item.fileData.contentFileType,
          ACL: 'public-read',
          Body: item.fileData.file
        }
        awsRef.putObject(params, (err, data) => {
          if (err) {
            console.log('Uploading Learning Content File Failed On S3: ' + err.stack)
          } else {
            var uri = item.uri
            if (uri.indexOf('?versionId=') === -1) {
              uri = uri.concat('?versionId=' + data.VersionId)
              this.updateFileUriAndVersionIdAfterS3Upload({uuid: item.uuid, uri: uri})
            }
          }
          let logoData = filesToBeUploaded[0]
          this.logoUri = logoData.uri
          this.logo = logoData.uri
          this.hideLoader()
        })
      })
    },
    showSuccessPopup () {
      console.log('file upload successful!')
    },
    institutionDataIsValid () {
      let isValid = true
      if (!this.title) {
        isValid = false
        this.errors.push('Error: Institution \'Name\' cannot be blank')
      }
      if (!this.type) {
        isValid = false
        this.errors.push('Error: Institution \'Type\' cannot be blank')
      }
      return isValid
    },
    onSubmit (isDone) {
      if (!this.institutionDataIsValid()) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: this.errors.join('\n')
        })
        this.errors = []
        return
      }
      let institution = this.institution
      const institutionData = {
        uuid: this.uuid,
        title: this.title,
        level: this.level,
        description: this.description,
        type: this.type,
        orgType:this.orgType,
        uri: this.uri,
        address: this.address,
        phonenumber: this.phonenumber,
        faxnumber: this.faxnumber,
        learnerDashboard: this.learnerDashboard,
        invoicePaymentLink: this.invoicePaymentLink,
        locationMapEmbbedURL: this.locationMapEmbbedURL,
        openId: this.openId,
        ssoUrl: this.ssoUrl,
        ssoLogoutUrl: this.ssoLogoutUrl,
        partnerHomeUrl: this.partnerHomeUrl,
        state: this.state,
        path: this.path,
        redirectUrl: this.redirectUrl,
        logo: this.logo,
        dashboardBgImage : this.dashboardBgImage,
        shortName: this.shortName,
        autoProvision: institution.autoProvision,
        autoProvisionRole: institution.autoProvisionRole,
        autoTaggingEnable: institution.autoTaggingEnable,
        courseDiscoveryConfigurationEnable: institution.courseDiscoveryConfigurationEnable,
        createPersonProfile: institution.createPersonProfile,
        customLandingPageViewer: institution.customLandingPageViewer,
        debugSearchRelevance: institution.debugSearchRelevance,
        employmentDataProvider: institution.employmentDataProvider,
        enableDashboard: institution.enableDashboard,
        enableExplore: institution.enableExplore,
        guestUserSessionCount: institution.guestUserSessionCount,
        lmsConnectorPackage: institution.lmsConnectorPackage,
        mc3Integration: institution.mc3Integration,
        nlpSearchEnable: institution.nlpSearchEnable,
        packages: institution.packages,
        pollingTimeMessages: institution.pollingTimeMessages,
        pollingTimeNotifications: institution.pollingTimeNotifications,
        sharePlanningStream: institution.sharePlanningStream,
        showDefaultLandingPage: institution.showDefaultLandingPage,
        showDuplicateContent: institution.showDuplicateContent,
        streamPackage: institution.streamPackage,
        semesterMap: institution.semesterMap,
        yearMap: institution.yearMap,
        currentSemester: institution.currentSemester,
        emailRecipients: institution.emailRecipients,
        emailSender: institution.emailSender,
        supportName: this.supportName,
        supportEmail: this.supportEmail,
        employerSupportName: this.employerSupportName,
        employerSupportEmail: this.employerSupportEmail,
        employerPhone: this.employerPhone,
        employerFax: this.employerFax,
        itemAnalysisReportEmails: this.itemAnalysisReportEmails,
        sendItemAnalysisReport: this.sendItemAnalysisReport,
        alertEmail: this.alertEmail,
        orientationEnrollmentEmail:this.orientationEnrollmentEmail,
        refundPolicy: this.refundPolicy,
        refundPolicyLink: this.refundPolicyLink,
        privacyPolicyLink: this.privacyPolicyLink
      }
      if (this.selfRegistrationMessage) {
      	institutionData.selfRegistrationMessage = this.selfRegistrationMessage
      } else {
      	institutionData.selfRegistrationMessage = undefined
      }

      if (this.purchaseExpirationMessage) {
      	institutionData.purchaseExpirationMessage = this.purchaseExpirationMessage
      } else {
      	institutionData.purchaseExpirationMessage = undefined
      }
      if (this.buyFlowMessage) {
      	institutionData.buyFlowMessage = this.buyFlowMessage
      } else {
      	institutionData.buyFlowMessage = 'DELETE'
      }
      if (this.learnFlowMessage) {
      	institutionData.learnFlowMessage = this.learnFlowMessage
      } else {
      	institutionData.learnFlowMessage = 'DELETE'
      }
      if (this.userSuspensionMessage) {
      	institutionData.userSuspensionMessage = this.userSuspensionMessage
      } else {
      	institutionData.userSuspensionMessage = 'DELETE'
      }


      this.showLoader()
      this.storeInstitution(institutionData).then(response => {
      	this.hideLoader()
        if (this.isSuccessfulResponse(response)) {
          let message = 'Institution "' + response.title + '" updated successfully.'
          this.notifySuccess(message)
        } else {
          let message = 'Unable to update Institution "' + this.title + '"'
          if (response.status === 409) {
          	message = 'Short Name is already in use.'
          }
          this.notifyFailure(message)
        }
        if (isDone) {
          return this.$router.push({ name: 'institutionDetails', params: { uuid: this.uuid } })
        }
      })
    },
    showLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.show()
      }
    },
    hideLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.hide()
      }
    },
    isSuccessfulResponse (response) {
      return response && response.uuid
    },
    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'currentEnvironment': state => state.learningContent.currentEnvironment
    }),

    institutionId () {
      return this.uuid || localStorage.getItem('institutionId')
    }
  }
}
</script>

<style scoped>
.input-group {
  z-index: 2;
}

.hidden-container {
  visibility: hidden;
  height: 1px;
}

.heading {
  font-size: 20px;
}

.label {
  font-size: 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/EditInstitutionDetails.vue